import { SingletonEnginnering } from "../nodes/_service/singletonEngineering"
import { ParseToNumber } from "./tools";

const MathEngine = {
  ERROR: -9999,

  lastError: "",

  tagValue: new Map(),

  sentence(expression)
  {

    if (expression == "-9999")
        return { value:this.ERROR, expressionResult: expression};

    let token = "";
    let result = 0;
    let dbTrueResult = 0;
    let dbFalseResult = 0;
    let boolResult = false;

    this.lastError = "";
    
    token = this.getToken(expression);

    if (token.toLocaleUpperCase() == "IF")
    {
        expression = this.processExpression(token, expression);
        token =  this.getToken(expression);
        if ((token.toLocaleUpperCase() == "("))
        {
            expression = this.processExpression(token, expression);
            boolResult = this.booleanExpression(expression);
            token =  this.getToken(expression);
            if ((token.toLocaleUpperCase() == ")"))
                expression = this.processExpression(token, expression);
            else
            {
                this.lastError = "')' esperado " + (expression != "" ? "próximo a '" + expression + "' \n" : "\n");
                return { value:this.ERROR, expressionResult: expression};
            }
        }
        else
        {
            boolResult = this.booleanExpression(expression);
        }

        token =  this.getToken(expression);

        if (!this.boolResult)
        {
            if (this.lastError != "")
            return { value:this.ERROR, expressionResult: expression};
        }

        if (!(token.toLocaleUpperCase() == "THEN"))
        {
            this.lastError = "'then' esperado \n";
            return { value:this.ERROR, expressionResult: expression};
        }

        expression = this.processExpression(token, expression);
        dbTrueResult = this.sentence(expression);

        token = this.getToken(expression);
        if (token.toLocaleUpperCase() == "ELSE")
        {
            expression = this.processExpression(token, expression);
            dbFalseResult = this.sentence(expression);
        }

        if (dbTrueResult == -9999) dbFalseResult = dbTrueResult;

            if (boolResult)
                result = dbTrueResult;
            else
                result = dbFalseResult;
    }
    else
    {
        if(String(expression).includes(">") || String(expression).includes("<") || String(expression).includes("="))
        {
            let objResult = this.booleanExpression(expression);
                boolResult = objResult.value;
                expression = objResult.expressionResult;

                if(!expression)
                    return { value: boolResult, expressionResult: expression};
        }
        else
        {
            let objResult = this.expression(expression)
            result = objResult.value
            expression = objResult.expressionResult
        }
    }

    return { value:result, expressionResult: expression};
  },

  getToken: function(expression)
  {
      let inIndex = 0;
      let token = "";
      let boNumber = false;
      let boVariable = false;
      let boCommand = false;
      let boRelation = false;
			if(!expression)
				return ''

      while (expression.length > 1 && expression.substr(0, 1) == " ")
      {
          expression = this.processExpression(expression.substr(0, 1), expression);
      }

      inIndex = 0;
      while (inIndex < expression.length)
      {
          let char = expression.substr(inIndex, 1)
          switch (char)
          {
              case "_":
              case "|":
              case "a":
              case "b":
              case "c":
              case "d":
              case "e":
              case "f":
              case "g":
              case "h":
              case "i":
              case "j":
              case "k":
              case "l":
              case "m":
              case "n":
              case "o":
              case "p":
              case "q":
              case "r":
              case "s":
              case "t":
              case "u":
              case "v":
              case "w":
              case "x":
              case "y":
              case "z":
              case "A":
              case "B":
              case "C":
              case "D":
              case "E":
              case "F":
              case "G":
              case "H":
              case "I":
              case "J":
              case "K":
              case "L":
              case "M":
              case "N":
              case "O":
              case "P":
              case "Q":
              case "R":
              case "S":
              case "T":
              case "U":
              case "V":
              case "W":
              case "X":
              case "Y":
              case "Z":
                  if (boRelation || boNumber || boCommand)
                      return token;

                  boVariable = true;
                  
                  token = token + expression.substr(inIndex, 1);

                  if (token.toLocaleUpperCase() == "THEN" || token.toLocaleUpperCase() == "ELSE" || token.toLocaleUpperCase() == "IF" || token.toLocaleUpperCase() == "AND" || token.toLocaleUpperCase() == "OR")
                  {
                      boCommand = true;
                      boVariable = false;
                  }
                  break;

              case "!":
              case "<":
              case ">":
              case "=":
              case "&":
              case "?":
              case ":":
                  if (boCommand || boVariable || boNumber)
                      return token;

                  boRelation = true;
                  token = token + expression.substr(inIndex, 1);
                  break;

              case "0":
              case "1":
              case "2":
              case "3":
              case "4":
              case "5":
              case "6":
              case "7":
              case "8":
              case "9":
                  if (boRelation || boCommand)
                      return token;

                  if (!boVariable)
                      boNumber = true;

                  token = token + expression.substr(inIndex, 1);
                  break;

              case ".":
                  token = token + expression.substr(inIndex, 1);
                  break;

              case "(":
              case ")":
              case "*":
              case "^":
              case "/":
              case "+":
              case "-":
                  if (boCommand || boRelation || boVariable || boNumber)
                      return token;

                  token = token + expression.substr(inIndex, 1);
                  return token;

              case ",":
                  if (!boVariable && !boCommand && !boRelation && boNumber) {
                      token = token + expression.substr(inIndex, 1);
                      break;
                  }

                  if (boCommand || boRelation || boVariable || boNumber)
                      return token;

                  token = token + expression.substr(inIndex, 1);
                  return token;

              case " ":
                  return token;

          }
          inIndex++;
      }
      return token;
  },

  processExpression: function (token, expression)
  {
		expression = this.removeSpace(expression)

		expression = expression.substr(token.length, expression.length - token.length);
		if (expression.length > 1)
			return this.removeSpace(expression)

		return expression;
  },

  removeSpace(expression){
    if (expression.length == 0)
      return expression;

    while (expression.length > 0 && (expression.substr(0, 1) == " " || expression.substr(0, 1) == " "))
      expression = expression.substr(1, expression.length - 1);

    return expression;
  },

  booleanExpression(expression)
  {
      let token = "";
      let boolResult = false;

      let objResult = this.booleanTerm(expression);
      boolResult = objResult.value;
      expression = objResult.expressionResult;
      
      token = this.getToken(expression);
      
      while (token.toLocaleUpperCase() == "OR")
      {
          expression = this.processExpression(token, expression);

          let objResult = this.booleanTerm(expression);
					let result = objResult.value;
					expression = objResult.expressionResult;

          boolResult = boolResult || result;

          token = this.getToken(expression);
      }

      return { value:boolResult, expressionResult: expression };
  },

  expression(expression)
  {
      let token = "";
      let result = 0.0;
      //console.log('---Iniciando expressão---', result );
      let objResult = this.term(expression);
      result = objResult.value;
      //console.log('expression term objResult 1:>> ', objResult);
      expression = objResult.expressionResult;
			
      if (result == -9999) return { value:result, expressionResult: expression };
			
      token = this.getToken(expression);
      //console.log('expression token :>> ', token);

      while (token == "-" || token == "+")
      {
          expression = this.processExpression(token, expression);

          let objResult = this.term(expression);
          //console.log('expression term objResult 2:>> ', objResult);
          let termResult = objResult.value;
          expression = objResult.expressionResult;

          if (termResult == -9999) return { value:termResult, expressionResult: expression };

          if (token == "-")
              result = result - termResult;

          if (token == "+")
              result = result + termResult;

          token = this.getToken(expression);
      }

      return { value:result, expressionResult: expression };
  },

  term(expression)
  {
      let token = "";
      let result = 0.0;

      //console.log('---Construindo termo de calculo---');
      let objResult = this.factor(expression);
      result = objResult.value
      expression = objResult.expressionResult
      //console.log('term factor objResult :>> ', result, objResult);
      //console.log('term factor expression :>> ', expression);

      if (result == -9999) return { value:result, expressionResult: expression };

      token = this.getToken(expression);
      //console.log('term token  :>> ', token );

      while (token == "*" || token == "/" || token == "^")
      {
          expression = this.processExpression(token, expression);

          if (token == "/")
          {
              let objFactor = this.factor(expression);
              let dbFactor = objFactor.value
              expression = objFactor.expressionResult
              //console.log('term factor objResult :>> ', objFactor);

              if (dbFactor == -9999) return { value:dbFactor, expressionResult: expression };

              if (dbFactor != 0)
                  result = result / dbFactor;
              else
                  result = 0;
          }

          if (token == "*")
          {
              let objFactor = this.factor(expression);
              let dbFactor = objFactor.value
              expression = objFactor.expressionResult
              //console.log('term factor objResult :>> ', objFactor);

              if (dbFactor == -9999) return { value:dbFactor, expressionResult: expression };

              result = result * dbFactor;
          }

          if (token == "^")
          {
              let objFactor = this.factor(expression);
              let dbFactor = objFactor.value
              expression = objFactor.expressionResult
              //console.log('term factor objResult :>> ', objFactor);

              if (dbFactor == -9999) return { value:dbFactor, expressionResult: expression };

              result = Math.Pow(result, dbFactor);
          }

          token = this.getToken(expression);
          //console.log('term 2 token :>> ', token);
      }

      return { value: result, expressionResult: expression };
  },

  factor(expression)
  {
    let token = "";
    let result = 0.0;
    let boNegative = false;

    token = this.getToken(expression);
    //console.log('factor token :>> ', token);

    if ((token.toLocaleUpperCase() == "TRULE"))
    {
        let variable1 = "";
        let variable2 = "";
        let result1 = "";

        expression = this.processExpression(token, expression);
        token = this.getToken(expression);
        if ((token == "("))
        {
            expression = this.processExpression(token, expression);
            variable1 = this.getToken(expression);

            expression = this.processExpression(variable1, expression);
            token = this.getToken(expression);

            expression = this.processExpression(token, expression);
            variable2 = this.getToken(expression);

            expression = this.processExpression(variable2, expression);
            token = this.getToken(expression);

            expression = this.processExpression(token, expression);
            result1 = this.getToken(expression);

            expression = this.processExpression(result1, expression);
            token = this.getToken(expression);

            if ((token == ")"))
            {
                expression = this.processExpression(token, expression);
            }
            else
            {
                this.lastError = "')' esperado " + (expression != "" ? "próximo a '" + expression + "' \n" : "\n");
                return { value:this.ERROR, expressionResult: expression };
            }
        }
        else
        {
            this.lastError = "'(' esperado próximo a '" + expression + "' \n";
            return { value:this.ERROR, expressionResult: expression };
        }
        result = (this.gtValue(variable2) * this.getValue(result1)) / this.getValue(variable1);
        return { value: result, expressionResult: expression };
    }

    if ((token == "-"))
    {
        boNegative = true;
        expression = this.processExpression(token, expression);
        let objResult = this.factor(expression)
				result = objResult.value
				expression = objResult.expressionResult

        if ((boNegative))
        {
            result = result * (-1);
        }
    }

    if (token.match(/^[0-9]*(?:\.[0-9]*)?$/))
    {
        try
        {
            if (token == "")
            {
                this.lastError = "Fim inesperado da sentença!";
                return { value:this.ERROR, expressionResult: expression };
            }
            expression = this.processExpression(token, expression);
						return { value:  parseFloat(token.replace(/,/g, ".")), expressionResult: expression };
        }
        catch (e)
        {
            this.lastError = "Valor numérico ou com formato incorreto: '" + token + "'!";
            return { value:this.ERROR, expressionResult: expression };
        }

    }

    if (!token.match(/^[0-9]*(?:\.[0-9]*)?$/) && token.length >= 2)
    {
        try
        {
            let value = 0
            result = 0;
            
            if(this.tagValue.has(token)) {
                //console.log('Factor Coletando Tag :>> ', token);
                value = this.tagValue.get(token) 
            }
            else if(SingletonEnginnering.hasMapping(token))
            {
                //console.log('Factor Coletando Tag :>> ', token);
                value = SingletonEnginnering.getValueByToken(token)
                value = !value ? this.ERROR : value;
            }
            
            //console.log('Factor Convertendo valor :>> ', value);
            result = ParseToNumber(value);
            //console.log('Factor Resultado Tag :>> ', result);

            if (value == "-9999") this.lastError = "variável '" + token + "' não encontrada \n";
            expression = this.processExpression(token, expression);
            return { value: result, expressionResult: expression };
        }
        catch (e)
        {
            this.lastError = "Valor não numérico ou com formato incorreto: '" + token + "'!";
            return { value: this.ERROR, expressionResult: expression };
        }
    }

    if ((token == "("))
    {
        expression = this.processExpression(token, expression);
        let objResult = this.expression(expression);
        //console.log('Factor expression objResult :>> ', objResult);
        result = objResult.value;
        expression = objResult.expressionResult;

        token = this.getToken(expression);
        //console.log('Factor getToken token :>> ', token);
        if (token == ")")
        {
            expression = this.processExpression(token, expression);
        }
        else
        {
            this.lastError = "')' esperado " + (expression != "" ? "próximo a '" + expression + "' \n" : "\n");
            return { value:this.ERROR, expressionResult: expression };
        }
    }

    return { value: result, expressionResult: expression };
  },

  booleanTerm(expression)
  {
    let token = "";
    let boolResult = false;

    let objResult = this.notFactor(expression);
    boolResult = objResult.value;
    expression = objResult.expressionResult;
    
    token = this.getToken(expression);
    
    while (token.toLocaleUpperCase() == "AND")
    {
        expression = this.processExpression(token, expression);

        token = this.getToken(expression);
        if (token == "(")
        {
            expression = this.processExpression(token, expression);
            let objResult = this.notFactor(expression);
            let value = objResult.value;
            expression = objResult.expressionResult;

            boolResult = boolResult & value;
            token = this.getToken(expression);
            if (token == ")")
            {
                expression = this.processExpression(token, expression);
            }
        }
        else
        {
						let objResult = this.notFactor(expression);
            let value = objResult.value;
            expression = objResult.expressionResult;
            boolResult = boolResult & value;
        }
        token = this.getToken(expression);
    }

    return { value:boolResult, expressionResult: expression };
  },

  notFactor(expression)
  {
      let token = "";
      let boolResult = false;
      let boNotResult = false;

      token = this.getToken(expression);

      if (token.toLocaleUpperCase() == "NOT")
      {
          boNotResult = true;
          expression = this.processExpression(token, expression);
      }

      let objResult = this.booleanFactor(expression);
      let value = objResult.value;
      expression = objResult.expressionResult;

      boolResult = (boNotResult ? !value : value);

      return { value:boolResult, expressionResult: expression };
  },

  booleanFactor(expression)
  {
      let token = "";
      let boolResult = false;


      token = this.getToken(expression);

      if (token.toLocaleUpperCase() == "TRUE")
      {
          expression = this.processExpression(token, expression);
          return { value:true, expressionResult: expression };
      }

      if (token.toLocaleUpperCase() == "FALSE")
      {
          expression = this.processExpression(token, expression);
          return { value:false, expressionResult: expression };
      }


      let objResult = this.relation(expression);
      boolResult = objResult.value;
      expression = objResult.experssionResult;

      return { value:boolResult, expressionResult: expression };
  },

  relation(expression)
  {
      let token = "";
      let boolResult = false;
      let result = 0.0;

      let { value, expressionResult } = {...this.expression(expression)};
			result = parseFloat(value)
			expression = expressionResult

      token = this.getToken(expression);
			
      if ((token == "<="))
      {
          expression = this.processExpression(token, expression);
          let objResult = this.expression(expression);
          let value = objResult.value;
          expression = objResult.expressionResult;

          boolResult = result <= value;
      }
      if ((token == ">="))
      {
          expression = this.processExpression(token, expression);
          let objResult = this.expression(expression);
          let value = objResult.value;
          expression = objResult.expressionResult;

          boolResult = result >= value;
      }
      if ((token == "<"))
      {
            expression = this.processExpression(token, expression);
            let objResult = this.expression(expression);
            let value = objResult.value;
            expression = objResult.expressionResult;

            boolResult = result < value;
        }
        if ((token == ">"))
        {
            expression = this.processExpression(token, expression);
            let objResult = this.expression(expression);

            let value = objResult.value;
            expression = objResult.expressionResult;

            boolResult = result > parseFloat(value);
        }
        if ((token == "=" || token == "=="))
      {
          expression = this.processExpression(token, expression);
          let objResult = this.expression(expression);
          let value = objResult.value;
          expression = objResult.expressionResult;

          boolResult = result == value;
      }
      if (token == "<>" || token == "!=")
      {
          expression = this.processExpression(token, expression);
          let objResult = this.expression(expression);
          let value = objResult.value;
          expression = objResult.expressionResult;

          boolResult = result != value;
      }

      return { value: boolResult, experssionResult: expression };
  }
}

export default MathEngine
